import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import MailEdit from "../../components/MailEdit";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';

const fetchMeetingRooms = async (event) => {
  console.log(event)
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/meetingRoomBasedOnLokasi`, {
    params: {
      address1: event
    }
  });
  return response.data;
};
const fetchBookings = async (date) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/BookingDate/${date}`);
    return response.data;
  };
  
  const Step1 = (props) => {

    const navigate = useNavigate();
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
      
      // Add your other styles here
    }));
    const styles = {
        root: {
          display: 'flex',
          overflow: 'auto',
        },
        tableWrapper: {
          width: 'calc(120% - 150px)', // Adjust as needed
          overflowX: 'auto',
        },
        stickyCell: {
          position: 'sticky',
        left: '0px',
        width: '150px', // Adjust this to change the width of the first sticky column
        backgroundColor: '#fff', // Ensure that the sticky cells have a background to avoid content overlapping
        border: '1px solid black',
        },
        subheadingCell: {
            backgroundColor: '#fad784',
            fontWeight: 'bold',
            textAlign: 'center',
          },
      }
      const changeLokasi = (event) => {
        setLokasi(event)
        if(event==="Office Tower Eightyeight@Kasablanka"){
        }else{
        }
        fetchMeetingRooms(event).then(res => {
          if (res) {
            let roomss = res.flatMap(address => {
              return (address.RuangMeeting || []).map(room => ({
                ...room,
                location: address.LokasiSingkatan
              }));
            });
            setRooms(roomss);
          } else {
            console.error('Response is undefined: ', res);
          }
        })
        .catch(err => console.error('An error occurred while fetching meeting rooms: ', err));
      } 
      const [categorias, setCategorias] = useState([]);

      const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }
      const [booked, setBooked] = useState(null);
      const [tanggalBooking, setTanggalBooking] = useState(new Date())
      const [lokasi,setLokasi] = useState()

      const times = Array.from({length: 48}, (_, i) => {
        const hour = Math.floor(i/2);
        const minute = i%2 === 0 ? '00' : '30';
        const nextHour = Math.floor((i+1)/2);
        const nextMinute = (i+1)%2 === 0 ? '00' : '30';
        return `${hour.toString().padStart(2, '0')}:${minute}-${nextHour.toString().padStart(2, '0')}:${nextMinute}`;
      });
      
    
      const [rooms, setRooms] = useState([]);
      useEffect(() => {
        getCategorias();
      const date = new Date(); // today's date
    const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
      
      
    fetchBookings(formattedDate).then(bookings => {
      console.log(bookings)
      const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
      setBooked(bookedCells);
    });
      }, []);

      const changeTanggalBooking = (event) => {
        setTanggalBooking(event)
        const date = new Date(event); // today's date
        const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
        fetchBookings(formattedDate).then(bookings => {
            console.log(bookings)
            const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
            setBooked(bookedCells);
          });
      }

      let locationSubHeadingIndex = -1; // This is for tracking when to insert the location subheading

      const moveToNewBooking =()=>{
        navigate("/NewBooking")
      }
      const [openCancellation, setOpenCancellation] = useState(false)
      const [toCancel,setToCancel]=useState();
      const cancelInitiation= (bookingData) => {
        setToCancel(bookingData)
        setOpenCancellation(true)
      }

      const cancelConfirmation = async () => {
        try {
          const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/cancelBookingItem`, { id: toCancel.id });
      
          // Refresh the page or update state as needed here...
          navigate("/calendar");
        } catch (error) {
          console.error('An error occurred while canceling the booking item.', error);
        }
      }
      if (props.currentStep !== 1) {
        return null;
      }
    return <Grid container style={styles.root}>
    <Dialog open={openCancellation} onClose={(event)=>setOpenCancellation(false)}>
    <Grid sx={{pl:3}}>
      <Grid xs={12}>
        <p>Yakin mau cancel?</p>
      </Grid>
      <Grid xs={12} container alignItems={"center"} justifyContent="center">
              <Button color="error" variant="contained" onClick={(event)=>setOpenCancellation(false)}>Jangan</Button>
      </Grid>
      <Grid xs={12} container alignItems={"center"} justifyContent="center">
        <Button variant="contained" sx={{mt:2}} onClick={(event)=>cancelConfirmation(toCancel)}>Yakin</Button>
      </Grid>
    </Grid>
    </Dialog>
    
               
                <Grid xs={12} >
                    <Grid sx={{pt:10, ml:3}} >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                    <MobileDatePicker 
                                        views={['year', 'month', 'day']}
                                        inputFormat="dd/MM/yyyy"
                                        value={tanggalBooking}
                                        onChange={(event)=>changeTanggalBooking(event)}
                                        renderInput={(params) => 
                                            <TextField 
                                                {...params} 
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment >
                                                            <CalendarMonthIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        }
                                    />

                        </LocalizationProvider>
                        <Grid container xs={6} sx={{mt:3}}>
                                                  <Select value={lokasi} whiteSpace="normal" onChange={event => changeLokasi(event.target.value)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>                            </Grid>
                                                <Grid container sx={{mt:2}}></Grid>
                        
                    </Grid>
                    
                    <Grid sx={{ml:3}}>
    <div style={styles.tableWrapper}>
      <TableContainer component={Paper} style={{ overflow: 'auto', border: '0.3px solid black',   // Thick Border
      boxShadow: '5px 5px 7px grey',}}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={styles.stickyCell}>Nama Ruangans</TableCell>
              {times.map((time, index) => (
                <TableCell key={index} style={styles.cell}>{time}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
    {rooms.flatMap((room, roomIndex) => {
        const elements = []; // This will contain the room row and possibly the location subheading

        // If it's a new location, insert a location subheading
        if (room.location !== rooms[locationSubHeadingIndex]?.location) {
            elements.push(
                <TableRow key={'loc_' + room.location}>
    <TableCell style={{...styles.locationSubheading,...styles.subheadingCell, position: 'sticky', left: 0}}>
        {room.location}
    </TableCell>
    <TableCell colSpan={times.length} style={{...styles.emptyCell ,...styles.subheadingCell,}}>
        {/* Empty Cell */}
    </TableCell>
</TableRow>

            );
            locationSubHeadingIndex = roomIndex;
        }

        // Add the room row
        elements.push(
            <TableRow key={roomIndex}>
                <TableCell style={styles.stickyCell}>{room.name}</TableCell>
                {times.map((time, timeIndex) => {
    const bookingData = booked?.find(
        booking => booking.code === room.code && booking.timeIndex === timeIndex + 1
    );
    
  
    const isBooked = !!bookingData;


    return (
        <Tooltip
            title={
                isBooked 
                ? (
                    <React.Fragment>
                        <div>
                            Nama Klien: {bookingData?.useData?.klien?.Nama || 'no data'}
                        </div>
                        <div>
                            Nama Perusahaan: {bookingData?.useData?.company?.namaPerusahaan || 'no data'}
                        </div>
                        <Button variant="contained" color="primary" onClick={(event)=>cancelInitiation(bookingData)}>
                            Cancel
                        </Button>
                    </React.Fragment>
                )
                : ''
            }
            key={timeIndex}
        >
        <StyledTableCell
                                                                style={{
                                                                  ...styles.cell,
                                                                  backgroundColor: isBooked ? 'red' : 'white',
                                                                  border: '1px solid black',
                    ...styles.cell
                                                                }}
                                                              />
        </Tooltip>
    );
})}
            </TableRow>
        );
        return elements;
    })}
</TableBody>

        </Table>
      </TableContainer>
    </div>
  </Grid>
  <Grid sx={{mt:5}}>
 
  </Grid>
                        </Grid>
                        
                </Grid>    
    };

    export default Step1;